import { useFeatureValue } from '@growthbook/growthbook-react';

import { GB_FEATURES } from 'dpl/shared/constants/gb_features';

const EXPERIMENT_VARIANTS = ['a', 'b'];

export default function usePuppyPageVariant() {
  const variant = useFeatureValue(GB_FEATURES.EXP_PUPPY_PAGE);

  const enabled = EXPERIMENT_VARIANTS.includes(variant);

  return { enabled, variant };
}
